import { type ReactNode } from 'react'
import { useLocation } from 'react-router-dom'
import loginRedirect from '@app/utils/loginRedirect'

export function ProtectedRoute({
  children,
  redirectTo,
}: {
  children: ReactNode
  redirectTo?: string
}) {
  const location = useLocation()
  const isAuthenticated = localStorage.getItem('isAuthenticated')
  const currentPath = location.pathname + location.search + location.hash

  // TODO: this is funky, there should be a more robust way of
  // handling the post-login process,
  const isLoggingIn = currentPath.includes('login=success')

  if (!isAuthenticated && !isLoggingIn) loginRedirect(redirectTo || currentPath)

  return <>{children}</>
}
